/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-24
 */
import React from 'react'
import { Layout } from 'antd'
import { useAppSelector } from '../../app/hooks'

import contact_us_icon from '../../images/contact_us.png'
import ContactUS from '../components/ContactUS'
import desktopLib from '../../utils/desktopLib'
import CONFIG from '../../constants/config'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout

export default function QA() {
  const config = useAppSelector((state) => state.main.config)

  return (
    <Layout>
      <PageHeader className="Header" title="联系客服" />
      <Content
        className="content"
        style={{ padding: ' 17px 30px 30px', backgroundColor: '#FFFFFF' }}
      >
        <div className="contact-container">
          <div className="contact-us">
            使用中遇到问题或者功能建议，请联系在线客服
            <ContactUS fromPage="联系客服">
              <img src={contact_us_icon} />
            </ContactUS>
          </div>
          <div className="info">
            <div>
              <h3>客服电话</h3>
              <div
                style={{
                  width: '140px',
                  height: '35px',
                  backgroundColor: '#E6E9ED',
                  color: '#0093FF',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {CONFIG.CUSTOMER_PHONE}
              </div>
            </div>
          </div>
        </div>
        {!desktopLib.isDesktop && (
          <>
            <h2>问题解答：</h2>
            <ol style={{ fontSize: '20px' }}>
              <li>
                IE浏览器无法正常使用本后台所有功能，请使用搜狗浏览器的【极速模式】打开本管理后台的页面。
              </li>
              <p>
                搜狗浏览器下载地址：
                <a
                  href="https://ie.sogou.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://ie.sogou.com/
                </a>
              </p>
              <li>
                如果下载的照片文件压缩包 .zip 在电脑上打不开，提示
                【Windows无法完成提取】， 请更换其他压缩软件解压。
              </li>
              <p>
                例如 360压缩，下载地址：
                <a
                  href="https://yasuo.360.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://yasuo.360.cn/
                </a>
              </p>
              <li>
                如果下载的照片，在windows系统电脑上打不开，可以更换其他看图软件。
              </li>
              <p>
                例如：2345看图王，下载地址：
                <a
                  href="http://pic.2345.cc/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://pic.2345.cc/
                </a>
              </p>
              <li>
                如果下载照片，或者考勤报表Excel文件后，在电脑上没有找到。可以去浏览器设置的文件下载路径查找文件：
              </li>
              <p>
                1）搜狗浏览器文件下载路径：
                <a
                  href="https://jingyan.baidu.com/article/6b1823097e53eafb58e159b9.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://jingyan.baidu.com/article/6b1823097e53eafb58e159b9.html
                </a>
              </p>
              <p>
                2）360浏览器文件下载路径：
                <a
                  href="https://jingyan.baidu.com/article/d8072ac43a064fad94cefd22.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://jingyan.baidu.com/article/d8072ac43a064fad94cefd22.html
                </a>
              </p>
              <p>
                3）QQ浏览器文件下载路径：
                <a
                  href="https://jingyan.baidu.com/article/2a138328ed5542074b134f4b.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://jingyan.baidu.com/article/2a138328ed5542074b134f4b.html
                </a>
              </p>
            </ol>
          </>
        )}
      </Content>
    </Layout>
  )
}
